import { CustomTabList, Heading } from "@/components";
import { Card, Tabs, TabsContent } from "@/components/ui";
import { tabs } from "./consts";
import {
  Curriculum,
  GeographicalRegions,
  InventorySetup,
  Submodule,
  TaskCategory,
  TaskTerm,
  TlmMaster,
  Kitfunction
} from "./TabsData";
import { Outlet } from "react-router-dom";
import InvoiceCode from "./TabsData/InvoiceCode/InvoiceCode";

const MasterData = () => {
  return (
    <div className="p-7">
      <Heading title="Master Data" />

      <Card className="py-5 pt-0 mt-6 shadow-none">
        <Tabs defaultValue="1" className="mt-6 flex">
          <CustomTabList tabs={tabs} className="mx-5" />
          <TabsContent value="1" className="px-0">
            <GeographicalRegions />
          </TabsContent>
          <TabsContent value="2" className="px-0">
            <TaskCategory />
          </TabsContent>
          <TabsContent value="3" className="px-0">
            <TaskTerm />
          </TabsContent>
          <TabsContent value="4" className="px-0">
            <Submodule />
          </TabsContent>
          <TabsContent value="5" className="px-0">
            <InventorySetup />
          </TabsContent>
          <TabsContent value="6" className="px-0">
            <TlmMaster />
          </TabsContent>
          <TabsContent value="7" className="px-0">
            <InvoiceCode />
          </TabsContent>
          <TabsContent value="8" className="px-0">
            <Curriculum />
          </TabsContent>
          {/* <TabsContent value="9" className="px-0">
            <Kitfunction />
          </TabsContent> */}
        </Tabs>
      </Card>
      <Outlet />
    </div>
  );
};

export default MasterData;
